import React from "react";

const AboutUs = () => {
  return (
    <>
      <div className="">
        {/* <div className="about-banner-content"></div> */}
        <h1 style={{ marginTop: "120px", textAlign: "center", fontSize: "36px", color: "#cc9051" }}>About The Artist</h1>
      </div>
      <div className="container owner-section">
        <div className="row  mt-3">
          <div className="col-md-6 backgroundImg">
            {/* <img src="./Images/radhika-new.JPEG" width="100%" /> */}
          </div>
          <div className="col-md-6 p-4">
            <h2>Renu Pande</h2>
            {/* <h6>Owner (Managing Director)</h6> */}
            <p>
              Discover the vibrant and intricate world of Indian folk and tribal art through the eyes of Renu Pande a talented artist from Lucknow, who embarked on
              her creative journey at the age of 60. With a passion that knows no age limits, she has skillfully honed her craft, blending traditional techniques with
              modern flair.
            </p>
            <p>Renu’s artwork is a testament to her dedication and love for Indian art forms. Her repertoire includes:</p>
            <ul style={{fontSize:'16px'}}>
              <li>Madhubani paintings, characterized by intricate patterns, geometric shapes, and nature-inspired motifs</li>
              <li>Gond paintings, showcasing the rich storytelling and symbolism of the Gond tribe</li>
              <li>Santhal art, highlighting the simplicity and elegance of rural Indian life</li>
              <li>Other Indian folk and tribal art forms, each with its unique style and cultural significance</li>
            </ul>
            <p>Each piece is a unique celebration of India's rich artistic heritage, carefully crafted to bring a taste of Indian beauty and elegance to your walls.The use of handmade paper,
                carefully selected for its unique texture and durability, provides the perfect canvas for Renu's vibrant colors and delicate brushstrokes.</p>
            <p>Through her paintings, Renu  aims to share the richness and diversity of Indian art with a global audience, inspiring a new appreciation for these traditional forms. Explore her collection and experience the vibrant spirit of India.</p>
          </div>
        </div>
        <div className="row mt-3 align-items-center">
          <div className="col-md-6">
            <h2>Radhika Kamdar</h2>
            {/* <h6>CEO (Chief Exceutive Officer)</h6> */}
            <p>
              Radhika, a talented mixed media artist from Mumbai, brings a fresh perspective to the world of Indian art. With a passion for experimentation and innovation,
              she combines traditional Indian elements with modern mixed media techniques to create vibrant, textured paintings that blend the old with the new.
            </p>
            <p>Featured on the TULIKA platform, Radhika's artwork offers a unique and exciting counterpoint to the traditional folk and tribal art forms showcased alongside it. We're thrilled to share her vision and talent with a wider audience,
              and look forward to seeing how her art continues to evolve and inspire.</p>
          </div>
          <div className="col-md-6">
            <img src="./Images/radhika.jpeg" width="100%" />
          </div>
        </div>
      </div>
      {/* <section className="about">
        <div className="container">
          <h2>What we do</h2>
          <p>
            Welcome to our painting gallery! We are passionate about art and
            strive to showcase the beauty of various painting styles. From
            vibrant landscapes to captivating portraits, our collection features
            exquisite works of art created by talented artists. Explore our
            gallery and immerse yourself in the world of art.
          </p>
          <div className="paintings">
            <div className="painting">
              <img src="./Images/about-1.jpg" alt="About Painting 1" />
              <h3>Abstract Expressionism</h3>
              <p>
                An exploration of emotions and spontaneity through bold
                brushstrokes and vibrant colors.
              </p>
            </div>
            <div className="painting">
              <img src="./Images/about-2.jpg" alt="About Painting 2" />
              <h3>Realism</h3>
              <p>
                Detailed and lifelike representations of subjects, capturing
                everyday scenes with precision.
              </p>
            </div>
            <div className="painting">
              <img src="./Images/about-3.jpg" alt="About Painting 3" />
              <h3>Impressionism</h3>
              <p>
                Soft brushwork and light effects that create a sense of movement
                and atmosphere.
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default AboutUs;
